var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00088501,
    width: 56,
    height: 56,
    rx: 4.75142,
    fill: "#F77E0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.712 25.9424C44.9829 25.9424 45.5134 24.3096 44.481 23.5569L28.7741 12.1314C28.5497 11.967 28.2789 11.8784 28.0008 11.8784C27.7227 11.8784 27.4519 11.967 27.2276 12.1314L11.5205 23.5569C10.4882 24.3054 11.0187 25.9424 12.2937 25.9424H14.8396V41.3245H11.8783C11.6974 41.3245 11.5493 41.4726 11.5493 41.6536V43.7923C11.5493 43.9732 11.6974 44.1213 11.8783 44.1213H44.1233C44.3043 44.1213 44.4523 43.9732 44.4523 43.7923V41.6536C44.4523 41.4726 44.3043 41.3245 44.1233 41.3245H41.162V25.9424H43.712ZM28.0008 15.0309L39.1507 23.1415H16.8508L28.0008 15.0309ZM17.8009 25.9424H22.6129V41.3245H17.8009V25.9424ZM25.5742 25.9424H30.3863V41.3245H25.5742V25.9424ZM38.2008 41.3245H33.3476V25.9424H38.2008V41.3245Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBank);
export default __webpack_public_path__ + "static/media/AddBank.8df0759ce41814e4d6fa42afa52549fc.svg";
export { ForwardRef as ReactComponent };